import React from "react";
import styled from "styled-components";
// Components
import ProjectBox from "../Elements/ProjectBox";
// Assets
import ProjectImg1 from "../../assets/img/projects/evidence.png";
import ProjectImg2 from "../../assets/img/projects/legalAid.jpg";
import ProjectImg3 from "../../assets/img/projects/scholarship.png";
import ProjectImg4 from "../../assets/img/projects/reliefWork.png";
import ProjectImg5 from "../../assets/img/projects/heritage.jpg";
import ProjectImg6 from "../../assets/img/projects/awareness.jpg";

export default function Initiatives() {
  return (
    <Wrapper id="projects">
      <div className="whiteBg">
        <div className="container">
          <HeaderInfo>
            <h1 className="font40 extraBold">Initiatives</h1>
            <p className="font13">
              ISRHB has taken various initiatives to unite Hindus from
              Bangladesh. At the same time those initiatives involves raising
              awareness on the issue of Hindu persecution in Bangladesh.
              <br />
              You can be the part of those initiatives according to your
              ability.
            </p>
          </HeaderInfo>
          <div className="row textCenter">
            <div className="col-xs-12 col-sm-4 col-md-4 col-lg-4">
              <ProjectBox
                img={ProjectImg1}
                title="Database on Hindu Atrocities"
                text="This project aims to build a secure & searchable database documenting atrocities committed against Hindus in Bangladesh since 1971 til date."
                link="https://hindu-persecution.com/"
              />
            </div>
            <div className="col-xs-12 col-sm-4 col-md-4 col-lg-4">
              <ProjectBox
                img={ProjectImg2}
                title="Legal Aid Team"
                text="Through this project, ISRHB will provide free legal assistance to affected minorities in Bangladesh. The organization will recruit qualified lawyers to support victims throughout the entire legal process, from filing cases to final judgment."
                link="#"
              />
            </div>
            <div className="col-xs-12 col-sm-4 col-md-4 col-lg-4">
              <ProjectBox
                img={ProjectImg3}
                title="Empowerment & Education"
                text="This project seeks to empower underprivileged Hindus through skill development and vocational training, enabling them to improve their socio-economic conditions"
                link="#"
              />
            </div>
          </div>
          <div className="row textCenter">
            <div className="col-xs-12 col-sm-4 col-md-4 col-lg-4">
              <ProjectBox
                img={ProjectImg4}
                title="Relief Work"
                text="During the time of calamities ISRHB will raise funds and provide relief work through this project."
                link="#"
              />
            </div>
            <div className="col-xs-12 col-sm-4 col-md-4 col-lg-4">
              <ProjectBox
                img={ProjectImg5}
                title="Heritage Preservation"
                text="Bring all the Hindu Temples or similar institutions under the ISRHB network and work with them to preserve our Hindu heritage and culture in Bangladesh"
                link="#"
              />
            </div>
            <div className="col-xs-12 col-sm-4 col-md-4 col-lg-4">
              <ProjectBox
                img={ProjectImg6}
                title="Awareness Building"
                text="Establishing strong connections between ISRHB and global human rights organizations, governments, and media outlets. The primary objective is to regularly share the database with these entities, ensuring that accurate data highlights the ground realities faced by Hindus in Bangladesh."
                link="#"
              />
            </div>
          </div>
          <br />
        </div>
      </div>
    </Wrapper>
  );
}

const Wrapper = styled.section`
  width: 100%;
`;
const HeaderInfo = styled.div`
  @media (max-width: 860px) {
    text-align: center;
  }
`;
